/* ZONLIDOOG (02-11-2026) · «Añadir al carrito» y «Comprar ahora» en tarjetas de oferta con variantes.
   Abre el mismo resumen de compra (zd-offer-dialog) con un selector de opción
   (talla, color…) y actualiza precio, cantidad mínima y subtotal según la variante elegida.
   En modo «Añadir al carrito» el botón principal añade la opción elegida sin ir al pago. */
(() => {
  if (window.ZDOfferVariants) return;
  window.ZDOfferVariants = true;

  function readVariants(card) {
    const source = card && card.querySelector('[data-zd-offer-variants]');
    if (!source) return null;
    try {
      const list = JSON.parse(source.textContent);
      return Array.isArray(list) && list.length ? { list, label: source.dataset.label || '' } : null;
    } catch (_) {
      return null;
    }
  }

  function applyToCard(card, variant) {
    card.dataset.offerVariant = String(variant.id);
    card.dataset.offerPrice = String(variant.price);
    card.dataset.offerPriceText = variant.price_text;
    card.dataset.offerRegularPrice = String(variant.regular);
    card.dataset.offerRegularPriceText = variant.regular_text;
    card.dataset.offerQuantityMin = String(variant.min || 1);
    card.dataset.offerQuantityStep = String(variant.step || 1);
    if (variant.max) card.dataset.offerQuantityMax = String(variant.max);
    else delete card.dataset.offerQuantityMax;
  }

  function parts(modal) {
    return {
      field: modal.querySelector('[data-zd-dialog-variant-field]'),
      label: modal.querySelector('[data-zd-dialog-variant-label]'),
      select: modal.querySelector('[data-zd-dialog-variant]')
    };
  }

  function setMode(modal, addLabel) {
    const title = modal.querySelector('#ZdOfferDialogTitle');
    const note = modal.querySelector('#ZdOfferDialogNote');
    if (title && modal.zdTitle === undefined) modal.zdTitle = title.textContent;
    modal.zdAddMode = Boolean(addLabel);
    modal.zdAddLabel = addLabel || '';
    modal.zdAddDone = false;
    if (title) title.textContent = addLabel || modal.zdTitle;
    if (note) note.hidden = Boolean(addLabel);
    if (addLabel && modal.checkout) modal.checkout.textContent = addLabel;
    if (modal.status) modal.status.style.color = '';
  }

  function cartBase(modal) {
    const root = window.Shopify?.routes?.root || modal.dataset.rootUrl || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  async function addFromDialog(modal) {
    const card = modal.card;
    const quantityInput = modal.quantity;
    const messages = modal.messages || {};
    const button = modal.checkout;
    if (!card || !quantityInput || !button) return;
    const quick = window.ZDOffersQuick;
    if (quick && card.dataset.offerEnd && !quick.isActive(card.dataset.offerEnd)) {
      modal.expire?.();
      return;
    }
    const quantity = Number(quantityInput.value);
    if (!quantityInput.checkValidity() || !Number.isSafeInteger(quantity) || quantity < 1) {
      modal.showStatus(messages.quantity_error || '');
      quantityInput.reportValidity();
      return;
    }
    modal.busy = true;
    button.disabled = true;
    button.textContent = messages.adding || modal.zdAddLabel;
    modal.showStatus('');
    if (modal.status) modal.status.style.color = '';
    try {
      const response = await fetch(cartBase(modal) + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(card.dataset.offerVariant), quantity }] })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || Number(data.status) >= 400) {
        throw new Error(typeof data.description === 'string' && data.description ? data.description : (messages.add_error || ''));
      }
      let cart = null;
      let warning = '';
      if (quick) {
        try {
          cart = card.dataset.offerDiscountCode ? await quick.applyDiscount(card.dataset.offerDiscountCode, card.dataset.offerEnd) : await quick.getCart();
        } catch (error) {
          cart = error.cart || null;
          warning = messages[error.key] || '';
        }
        if (cart) quick.refreshCart(cart, card.dataset.offerVariant);
      }
      modal.zdAddDone = true;
      modal.showStatus(warning || messages.added || '', false);
      if (modal.status && !warning) modal.status.style.color = '#193757';
      button.textContent = messages.view_cart || modal.zdAddLabel;
    } catch (error) {
      modal.showStatus(error.message || messages.add_error || '');
      button.textContent = modal.zdAddLabel;
    } finally {
      modal.busy = false;
      button.disabled = false;
    }
  }

  function prepare(modal, card) {
    setMode(modal, '');
    const { field, label, select } = parts(modal);
    if (!field || !select) return;
    const data = readVariants(card);
    modal.zdVariantCard = data ? card : null;
    modal.zdVariantList = data ? data.list : null;
    if (!data) {
      field.hidden = true;
      select.replaceChildren();
      return;
    }
    const soldOut = select.dataset.soldOut || '';
    label.textContent = data.label;
    select.replaceChildren(...data.list.map(variant => {
      const option = new Option(variant.available ? variant.title : variant.title + (soldOut ? ' · ' + soldOut : ''), String(variant.id));
      option.disabled = !variant.available;
      return option;
    }));
    const current = data.list.find(v => String(v.id) === card.dataset.offerVariant && v.available) || data.list.find(v => v.available);
    if (current) {
      select.value = String(current.id);
      applyToCard(card, current);
    }
    select.disabled = false;
    field.hidden = false;
  }

  function refresh(modal, card) {
    const price = modal.querySelector('[data-zd-dialog-price]');
    const compare = modal.querySelector('[data-zd-dialog-compare]');
    const quantity = modal.querySelector('[data-zd-dialog-quantity]');
    if (price) price.textContent = card.dataset.offerPriceText;
    if (compare) {
      compare.textContent = card.dataset.offerRegularPriceText;
      compare.hidden = card.dataset.offerPrice === card.dataset.offerRegularPrice;
    }
    if (quantity && !quantity.disabled) {
      quantity.min = card.dataset.offerQuantityMin || '1';
      quantity.step = card.dataset.offerQuantityStep || '1';
      if (card.dataset.offerQuantityMax) quantity.max = card.dataset.offerQuantityMax;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  // Antes de abrir el resumen (cualquier «Comprar ahora» de oferta), prepara o esconde el selector.
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-zd-offer-buy], [data-zd-offer-variant-buy], [data-zd-offer-variant-add]');
    if (!trigger) return;
    const card = trigger.closest('[data-zd-offer-card]');
    const modal = document.querySelector('zd-offer-dialog');
    if (!card || !modal) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!modal.openFor || !modal.dialog || !modal.dialog.showModal) return;
    if (trigger.getAttribute('aria-disabled') === 'true' || modal.busy) return;
    prepare(modal, card);
    if (trigger.hasAttribute('data-zd-offer-variant-buy')) {
      event.preventDefault();
      modal.openFor(card, trigger);
    } else if (trigger.hasAttribute('data-zd-offer-variant-add')) {
      event.preventDefault();
      modal.openFor(card, trigger);
      if (modal.dialog.open && modal.card === card) setMode(modal, trigger.textContent.trim());
    }
  }, true);

  // En modo «Añadir al carrito», el botón principal del resumen añade sin ir al pago.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-zd-dialog-checkout]');
    if (!button) return;
    const modal = button.closest('zd-offer-dialog');
    if (!modal || !modal.zdAddMode) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (modal.busy) return;
    if (modal.zdAddDone) {
      window.location.assign(modal.dataset.cartUrl || cartBase(modal) + 'cart');
      return;
    }
    addFromDialog(modal);
  }, true);

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-zd-dialog-variant]');
    if (!select) return;
    const modal = select.closest('zd-offer-dialog');
    const card = modal && modal.zdVariantCard;
    const variant = modal && modal.zdVariantList && modal.zdVariantList.find(v => String(v.id) === select.value);
    if (!card || !variant || !variant.available || modal.busy) return;
    applyToCard(card, variant);
    refresh(modal, card);
    if (modal.zdAddMode) {
      modal.zdAddDone = false;
      if (modal.checkout) modal.checkout.textContent = modal.zdAddLabel;
      modal.showStatus?.('');
    }
  });
})();
